export abstract class WhatsNewState {
  public static get(): boolean | undefined {
    const whatsNewStatus = window.sessionStorage.getItem("whats-new-seen");
    return whatsNewStatus ? JSON.parse(whatsNewStatus) : undefined;
  }

  public static set(status: boolean) {
    window.sessionStorage.setItem("whats-new-seen", status.toString());
  }

  public static clear() {
    window.sessionStorage.removeItem("whats-new-seen");
  }
}
